import { Pros } from 'context/page-form-context';

interface ProsContentMapProps {
  pros: Pros;
}

const ProsContentMap = ({ pros }: ProsContentMapProps) => {
  return (
    <div>
      {pros.map((pro) => {
        if (pro !== '') return <li key={pro}>{pro.toString()}</li>;
        return <div key={pro} />;
      })}
    </div>
  );
};

export { ProsContentMap };
